import React, { useState, useEffect, useCallback } from 'react'
import { useParams } from 'react-router'
import style from './audit.module.sass'
import { Button, Collapse, DatePicker, Select, Dropdown, Icon, Spin } from 'antd'
import moment from 'moment'
import { Http } from "../../../helpers/axois";
import { useToast } from '../../../helpers/commonFunction'
import InfScroll from 'react-infinite-scroll-component'
import { dropDownList, AuditPropsDropDown } from './AuditPropsDropDown'
import { AuditRecordHeader } from './AuditRecordHeader'
import { QueryTag, AuditAPIData, SortOrder, AuditResponseData, DateMode, AuditParams } from './auditInterface'
import { getRandomId } from "../../../utils/random-id";
import { useHistory } from 'react-router-dom'
import "./index.css"
import { useSelector } from 'react-redux'
import NoData from '../../apps/NoData'
import { ReactComponent as WarningIcon } from '../../../assets/svg/warningIcon.svg'
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const InfiniteScroll: any = InfScroll

const ButtonGroup = Button.Group
const Panel = Collapse.Panel
const RangePicker = DatePicker.RangePicker
const Option = Select.Option

const AuditHistory = () => {

    const { ErrorToast, SuccessToast } = useToast();
    const { orgId }: AuditParams = useParams()
    const [startDate, setStartDate] = useState<any>(null)
    const [endDate, setEndDate] = useState<any>(null)
    const [dateMode, setDateMode] = useState<DateMode>(DateMode.ALL)
    const [auditList, setAuditList] = useState<AuditResponseData[]>([])
    const [exportReq,setExportReq]=useState<AuditAPIData>({})
    const limit = 30
    const [queryProp, setQueryProp] = useState('')
    const [queryDropVisible, setQueryDropVisible] = useState(false)
    const [queryTags, setQueryTags] = useState<QueryTag[]>([])
    const queryTagLength = queryTags.length
    const [sortOrder, setSortOrder] = useState<SortOrder>(SortOrder.DESC)
    const [cursor, setCursor] = useState<string>('')
    const [hasMore, setHasMore] = useState(false)
    const [loading, setLoading] = useState(false)
    const [apiData, setApiData] = useState<AuditAPIData>({})
    const history = useHistory();
    const [canFetchData,setCanFetchData]=useState(false);

    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
    var canView = orgPermissions.includes('audit.View');
    const getAudit = useCallback((organizationId?: string, data: AuditAPIData = {}, flush: boolean = true, auditList: AuditResponseData[] = []) => {
        organizationId && Http.post(`/audit?orgId=${organizationId}`, data).subscribe((res: any) => {
            if (res.length > 0) {
                setCursor(res[res.length - 1].created_at)
                if (res.length < limit) {
                    setHasMore(false)
                } else {
                    setHasMore(true)
                }
                if (flush) {
                    setAuditList(res)
                    setLoading(false)
                } else {
                    setAuditList([...auditList, ...res])
                    setLoading(false)
                }
            } else {
                setHasMore(false)
                if (flush) {
                    setAuditList(res)
                } else {
                    setAuditList([...auditList, ...res])
                }
                setLoading(false)
            }
        setExportReq(data)
        },(e)=>{
            if(e==="Forbidden"){
                canView=false
            }
        })
    }, [])

    useEffect(() => {
        if (canFetchData) {
            setLoading(true)
            orgId && getAudit(orgId,{
                conditions: queryTags,
                limit,
                // use parseToDate from utils for local
                startDate: startDate && moment(startDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
                endDate: endDate && moment(endDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
                sort: sortOrder
            })
            setApiData({
                limit
            })
        }
    }, [getAudit, orgId,startDate,endDate,sortOrder])

    useEffect(() => {
        if (dateMode === DateMode.ALL) {
            setEndDate(moment())
            setStartDate(null)
            setCanFetchData(true)
        } else if (dateMode === DateMode.WEEK) {
            setEndDate(moment().endOf('day'))
            setStartDate(moment().subtract(7, 'days').startOf('day'))
        } else if (dateMode === DateMode.MONTH) {
            setEndDate(moment().endOf('day'))
            setStartDate(moment().subtract(1, 'month').startOf('day'))
        } else if (dateMode === DateMode.YEAR) {
            setEndDate(moment().endOf('day'))
            setStartDate(moment().subtract(1, 'year').startOf('day'))
        }
    }, [dateMode])

    const onVisible = (e: boolean) => {
        setQueryDropVisible(e)
    }

    const filterAudit = () => {
        setLoading(true)
        setAuditList([])
        getAudit(orgId, {
            conditions: queryTags,
            limit,
            // use parseToDate from utils for local
            startDate: startDate && moment(startDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
            endDate: endDate && moment(endDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
            sort: sortOrder
        })
        setApiData({
            conditions: queryTags,
            limit,
            // use parseToDate from utils for local
            startDate: startDate && moment(startDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
            endDate: endDate && moment(endDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
            sort: sortOrder
        })
    }

    const fetchMoreAudits = () => {
        const fetchApiData = {
            ...apiData,
            // use parseToDate from utils for local
            cursor
        }
        getAudit(orgId, fetchApiData, false, auditList)
    }
    const exportDocument = async () => {
        const data = {
        startDate: exportReq.startDate ? moment(exportReq.startDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : cursor,
        sort: sortOrder,
        endDate: exportReq.endDate ? moment(exportReq.endDate).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') ,
        conditions: queryTags || []
        }
        Http.post(`/audit?orgId=${orgId}&export=csv`, data).subscribe((res: any) => {
            if (res?.message === "Submitted Successfully") {
                SuccessToast(`Request submitted! Find it under "View Downloads" to track progress or download when ready.`)
            }

        }, (e) => {
            if (e === "Forbidden") {
                ErrorToast("Not Authorized: Please request owner of this organization to provide access")
            } else {
                ErrorToast('Error exporting audit logs')
            }
        })


    }
    function handleChange(value: string) {
        if (value === "export") {
            exportDocument();
        } else if (value === "view") {
            history.push(`/organization/${orgId}/downloads`)
        }
    }
    return (
        <div data-test-id='audit-container' className={style.auditContainer + ' override-audit-container'}>
           {canView ? <>
            <div data-test-id='audit-topbar' className={style.topBar}>
                <div className={style.title}>
                    <div className={style.titleContent}>
                        <h3>Audit History</h3>
                        <p>View audits of organization</p>
                    </div>
                </div>
                <div className={style.actionContainer}>
                    <div className={style.buttonContainer}>
                        <ButtonGroup>
                            <Button data-test-id='audit-all' ghost={dateMode !== 'all'} type="primary" onClick={() => setDateMode(DateMode.ALL)}>ALL</Button>
                            <Button data-test-id='audit-week' ghost={dateMode !== 'week'} type="primary" onClick={() => setDateMode(DateMode.WEEK)}>WEEK</Button>
                            <Button data-test-id='audit-month' ghost={dateMode !== 'month'} type="primary" onClick={() => setDateMode(DateMode.MONTH)}>MONTH</Button>
                            <Button data-test-id='audit-year' ghost={dateMode !== 'year'} type="primary" onClick={() => setDateMode(DateMode.YEAR)}>YEAR</Button>
                        </ButtonGroup>
                    </div>
                    <div className={style.dateText}>DATE : </div>
                    <div className={style.dateContainer}>
                        <RangePicker
                            data-test-id='audit-datepicker'
                            value={[startDate, endDate]}
                            onChange={(e) => {
                                setDateMode(DateMode.NONE)
                                if (e.length > 1) {
                                    setStartDate(e[0] && e[0].startOf('day'))
                                    setEndDate(e[1] && e[1].endOf('day'))
                                } else {
                                    setStartDate(null)
                                    setEndDate(null)
                                }
                            }}
                            disabledDate={(current: any) => current && current > moment().endOf('day')}
                            dropdownClassName='audit-date-picker' />
                    </div>
                    <div className={style.selectContainer}>
                        <Select data-test-id='audit-sort' onChange={(e: SortOrder) => setSortOrder(e)} value={sortOrder}>
                            <Option data-test-id='newest_first' value='descending'>NEWEST FIRST</Option>
                            <Option data-test-id='oldest_first' value='ascending'>OLDEST FIRST</Option>
                        </Select>
                    </div>
                </div>
            </div>
            {<div className={style.auditDownloadDiv}>
                <div data-test-id='audit-query-bar' className={style.queryBar}>
                    <Dropdown visible={queryDropVisible} onVisibleChange={onVisible} trigger={['click']} overlay={(<AuditPropsDropDown queryProp={queryProp} setQueryProp={setQueryProp} />)} overlayClassName='audit-dropdown'>
                        <input
                            data-test-id='audit-condition'
                            placeholder='Enter filter condition'
                            value={queryProp}
                            onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                    const key = queryProp.includes(':') && queryProp.split(':')[0].trim()
                                    if (key && dropDownList.includes(key)) {
                                        if (queryProp.split(':').length > 2) {
                                            ErrorToast('Filter value contains semi-colon')
                                        } else {
                                            setQueryDropVisible(false)
                                            setQueryTags([...queryTags, {
                                                id: getRandomId(),
                                                key,
                                                value: queryProp.split(':')[1].trim()
                                            }])
                                            setQueryProp('')
                                        }
                                    } else {
                                        ErrorToast('Invalid filter key')
                                    }
                                }
                            }}
                            onChange={(e) => {
                                const value: string = e.target.value
                                setQueryProp(value)
                                if (value.includes(':')) {
                                    setQueryDropVisible(false)
                                } else {
                                    setQueryDropVisible(true)
                                }
                            }}
                        />
                    </Dropdown>
                    <div className={style.tagsContainer}>
                        {
                            queryTags.map((item: QueryTag) => {
                                return (
                                    <span data-test-id={`audit-query-tag-${item.id}`} key={item.id} className={style.queryTag}>
                                        {item.key} : {item.value}
                                        <Icon className={style.queryClose} data-test-id={`audit-query-tag-remove-${item.key}`} onClick={() => setQueryTags(queryTags.filter((tag: QueryTag) => tag.id !== item.id))} type="close-circle" theme="filled" />
                                    </span>
                                )
                            })
                        }
                    </div>
                    <div data-test-id='audit-filter' className={`${style.filterButton}`} onClick={filterAudit}>
                        FILTER
                    </div>
                </div>
                <div className="downloadButton" ><Select
                    dropdownMenuStyle={{ width: "auto" }}
                    dropdownClassName='downloadsDropdown'
                    className="downloadSelect" value="Downloads" placeholder="Downloads" style={{ width: 134 }} onChange={handleChange}>
                    <Option value="export">Export</Option>
                    <Option value="view">View Downloads</Option>
                </Select>
                    <div className={style.divider}></div>
                </div>
            </div>}
            {
                (!loading && auditList && auditList.length > 0) ?
                    (
                        <>
                            <div data-test-id='audit-table-header' className={style.tableHeader}>
                                <span>Operation</span>
                                <span className={style.headerHalf}>
                                    <span>Summary</span>
                                    <span className={style.headerLast}>Timestamp</span>
                                </span>
                            </div>
                            <div data-test-id='audit-scroll-div' className={style.dataContainer} id='scrollableDiv'>
                                <InfiniteScroll
                                    data-test-id='audit-infinite-scroll-container'
                                    loader={<div data-test-id='audit-infinite-spinner' className={style.loadingContainer}><Spin indicator={antIcon} style={{ color: '#15808C' }} /></div>}
                                    dataLength={auditList.length}
                                    next={fetchMoreAudits}
                                    hasMore={hasMore}
                                    scrollableTarget="scrollableDiv"
                                >
                                    <Collapse>
                                        {
                                            auditList.map((auditItem: AuditResponseData, index: number) => {
                                                return (
                                                    <Panel data-test-id={`audit-panel-${index}`} header={<AuditRecordHeader item={auditItem} />} key={index}>
                                                        <pre className={style.jsonText}>{auditList.length > 0 && JSON.stringify(auditItem, undefined, 4)}</pre>
                                                    </Panel>
                                                )
                                            })
                                        }
                                    </Collapse>
                                </InfiniteScroll>
                            </div>
                        </>
                    )
                    :
                    (loading && auditList && auditList.length < 0)
                        ?
                        <div data-test-id='audit-initial-spinner' className={style.initialLoadingContainer}><Spin indicator={antIcon} style={{ color: '#15808C' }} /></div>
                        :
                        <div data-test-id='audit-no-data' className={style.noDataContainer}>No data</div>
            }

            </> :
                        <NoData
                            svg={WarningIcon}
                            header='Not Authorized'
                            content='Please request owner of this organization to provide access'
                            noButton={true}
                        />
            }
            
        </div>
    )
}

export default AuditHistory
